export default __webpack_public_path__ + "static/media/icon-unlocked.78714c57.svg";